import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

const New = ({
  isModalOpen,
  onCloseHandler,
  onSubmitHandler,
  error,
  submitting,
}) => (
  <Form
    isModalOpen={isModalOpen}
    onCloseHandler={onCloseHandler}
    onSubmitHandler={onSubmitHandler}
    error={error}
    submitting={submitting}
    action='new'
  />
);

New.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

New.defaultProps = {
  isModalOpen: false,
  error: null,
  submitting: false,
};

export default New;
